import React, {useState} from 'react'
import styled from 'styled-components'
import {Checkbox} from '../../../components/library/form/checkbox'
import {Toggle} from '../../../components/library/toggles/toggle'
import {FormModal} from '../../../components/modals'
import {EnvironmentsSelected} from './index'

const ToggleContent = styled.div`
  padding: 20px;
`

const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  ${ToggleContent}:first-of-type {
    border-radius: ${p => p.theme.borderRadius} ${p => p.theme.borderRadius} 0 0;
  }
  label:last-child {
    border-radius: 0 0 ${p => p.theme.borderRadius} ${p => p.theme.borderRadius};
    border-bottom: 1px solid ${p => p.theme.grey10};
  }
  label:only-child,
  ${ToggleContent}:only-child {
    border-radius: ${p => p.theme.borderRadius};
    border-bottom: 1px solid ${p => p.theme.grey10};
  }
  label,
  ${ToggleContent} {
    padding: 15px;
    border: 1px solid ${p => p.theme.grey10};
    border-bottom: none;
  }
`

const HelpText = styled.p`
  color: ${p => p.theme.grey50};
  font-size: ${p => p.theme.fontSizeS};
  line-height: ${p => p.theme.lineHeightCompact};
  margin: 20px 0 0;
`

const ErrorText = styled.p`
  color: ${p => p.theme.redDark};
  font-size: ${p => p.theme.fontSizeS};
  line-height: ${p => p.theme.lineHeightCompact};
  margin: 20px 0 0;
`

export const EnvironmentAccess = ({
  environments,
  selectedEnvironments,
  handleClose,
  onUpdate
}: {
  environments: {name: string; id: string}[]
  selectedEnvironments: EnvironmentsSelected
  handleClose: () => void
  onUpdate: (update: EnvironmentsSelected) => void
}) => {
  const [state, setState] = useState<EnvironmentsSelected>(selectedEnvironments)
  const [mode, setMode] = useState<'all' | 'some'>(
    selectedEnvironments ? 'some' : 'all'
  )
  const isValid = mode === 'all' || !!(state && state.length > 0)
  return (
    <FormModal
      title="Edit environment access"
      submitText="Confirm"
      isValid={isValid}
      handleClose={handleClose}
      onSubmit={() => {
        onUpdate(mode === 'all' ? null : state)
      }}
    >
      <>
        <InputGroup>
          <ToggleContent>
            <Toggle
              style={{width: '100%'}}
              options={[
                {
                  text: 'All environments',
                  value: 'all'
                },
                {
                  text: 'Selected environments',
                  value: 'some'
                }
              ]}
              value={mode}
              onChange={m => {
                if (m === 'some' && !state) {
                  setState(environments.map(e => e.id))
                }
                setMode(m)
              }}
              legacyMode={true}
            />
            {mode === 'all' ? (
              <HelpText>
                Access to all environments within this organisation, including
                new environments added in future.
              </HelpText>
            ) : (
              <HelpText>Access to selected environments only.</HelpText>
            )}
          </ToggleContent>

          {mode === 'some' &&
            environments.map(e => {
              return (
                <Checkbox
                  key={e.id}
                  label={e.name}
                  checked={state ? state.includes(e.id) : false}
                  onChange={checked => {
                    setState(s => {
                      if (checked) {
                        return s ? s.concat(e.id) : [e.id]
                      } else {
                        return s ? s.filter(id => id !== e.id) : []
                      }
                    })
                  }}
                />
              )
            })}
        </InputGroup>
        {!isValid && (
          <ErrorText>You must select at least one environment</ErrorText>
        )}
      </>
    </FormModal>
  )
}
